import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    "element-loading-text": "Loading...",
    "element-loading-spinner": "el-icon-loading",
    data: _ctx.arealist,
    "max-height": _ctx.paneHeight,
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        prop: "town",
        label: "エリア名"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.gst_name) + _toDisplayString(scope.row.town), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "order_qty",
        label: "配布部数",
        "class-name": "right",
        width: "100"
      }),
      _createVNode(_component_el_table_column, {
        label: "反響率",
        "class-name": "right",
        width: "80"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(((scope.row.resval + scope.row.get_order_qty) / scope.row.order_qty * 100).toFixed(3)) + "% ", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "問合数",
        width: "150"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_input_number, {
            size: "mini",
            placeholder: "0",
            min: 0,
            step: 1,
            modelValue: scope.row.resval,
            "onUpdate:modelValue": ($event: any) => ((scope.row.resval) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "受注数",
        width: "150"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_input_number, {
            size: "mini",
            placeholder: "0",
            min: 0,
            step: 1,
            modelValue: scope.row.get_order_qty,
            "onUpdate:modelValue": ($event: any) => ((scope.row.get_order_qty) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "受注金額",
        width: "150"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_input_number, {
            size: "mini",
            placeholder: "0",
            min: 0,
            step: 1000,
            modelValue: scope.row.get_order_mnt,
            "onUpdate:modelValue": ($event: any) => ((scope.row.get_order_mnt) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "反響コメント",
        width: "200"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_input, {
            size: "mini",
            placeholder: "Please Input",
            modelValue: scope.row.rescom,
            "onUpdate:modelValue": ($event: any) => ((scope.row.rescom) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data", "max-height"])), [
    [_directive_loading, _ctx.loading]
  ])
}